import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import '../App.css';
import InputsForm from '../components/inputs_and_outputs';
import NavBar from '../components/NavBar';

const theme = createTheme({
    palette: {
        background: {
            default: '#328fa8',
        },
        primary: {
            main: '#282c34',
        },
    },
});

const HomePage = () => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline /> {/* This helps in applying consistent base styles */}
            <div className="App">
                <NavBar />
                <InputsForm />
            </div>
        </ThemeProvider>
    );
}

export default HomePage;